import { Component, OnInit } from '@angular/core';
import { ApiConnectorService } from '../../../___LOGIC/__api/api-connector.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SecurityLayerService } from '../../../___LOGIC/__auth/security-layer.service';
import { TranslationService } from 'src/app/___LOGIC/___common/__language/translation.service';
import { EmailService } from 'src/app/___LOGIC/__email/email.service';
import { ActivatedRoute } from '@angular/router';
import { matchPasswordValidator } from 'src/app/___LOGIC/__auth/match-password.validator';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { ConfigService } from 'src/app/___LOGIC/___common/__config/config.service';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css']
})
export class RecoverPasswordComponent implements OnInit {

  token;
  hide = true;
  expired = false;
  mode = 'sendResetLink';

  signin: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.email, Validators.required ]),
    password: new FormControl('', [Validators.required, Validators.min(8) ]),
    passwordConfirm: new FormControl('', [Validators.required, Validators.min(8) ])},
    { validators: matchPasswordValidator }
  );
  
  get emailInput() { return this.signin.get('email'); }
  get passwordInput() { return this.signin.get('password'); }
  get passwordConfirmInput() { return this.signin.get('passwordConfirm'); }

  loginObj = {
    path: 'recover-password',
    username: '', 
    token: null,
    password: this.passwordInput.value
  };

  passwordRequirements = {
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false
  };

  constructor(private apiConnector: ApiConnectorService,private securityLayer: SecurityLayerService,private translationService: TranslationService,private emailService: EmailService,private route:ActivatedRoute,private guiFlow: GuiFlowService,private configService: ConfigService) { }

  ngOnInit(): void {
    if(this.route.snapshot.paramMap.get('token')){
      this.mode = 'setNewPass';
      this.token = this.route.snapshot.paramMap.get('token');
      //this.preRegistered = true;
      this.load();
    }
    this.signin.get('password').valueChanges.subscribe(value => this.onPasswordInput(value));
  }

  async load(){
    let url = this.configService.getApiUrlRefactor('auth')+"check_pass_token.php?token="+this.token;
    const data = await this.securityLayer.checkToken(url).toPromise();
    this.securityLayer.setIsLoading(false);
    if(data['OK'] && data['OK'].username){
      this.loginObj.username = data['OK'].username;
      this.loginObj.token = this.token;
    }else{
      console.log('Error on token validation');
      this.expired = true;
      this.mode = 'sendResetLink';
      this.guiFlow.openSimpleSnackBar('Enlace expirado','error');
    }
  }

  onPasswordInput(password: string): void {
    this.passwordRequirements.minLength = password.length >= 8;
    this.passwordRequirements.uppercase = /[A-Z]/.test(password);
    this.passwordRequirements.lowercase = /[a-z]/.test(password);
    this.passwordRequirements.number = /\d/.test(password);
    this.passwordRequirements.specialChar = /[\W_]/.test(password);
  }

  areFieldsFilled(){
    return (this.passwordConfirmInput.value && this.passwordConfirmInput.value) && this.passwordConfirmInput.value == this.passwordInput.value && this.passwordInput.valid;
  }

  setNewPass(){
    this.loginObj.password = this.passwordInput.value;
    this.securityLayer.updatePassword(this.loginObj);
  }

  contactSupport(){
    console.log('CONTACTAR SOPORTE');
  }

  isLoading(){
    return this.securityLayer.isLoginManagerLoading();
  }

  recoverPass() {
    if (!this.emailInput.value) return;
    this.emailService.recoverPassword(this.emailInput.value)
      .subscribe(
        res => this.processRecoverPass(res),
        err => console.error('Error sending recovery email:', err)
      );
  }

  generateNewLink(){
    this.loginObj.username = this.emailInput.value;
    this.securityLayer.generateNewLink(this.loginObj);
  }
  
  processRecoverPass(res){
    if(res){
      if(res.OK){
        debugger
      }
    }else{
      debugger;
    }
  }

  onKeyUp(event: KeyboardEvent){
    if (event.key && event.key === "Enter") {
      this.recoverPass();
    }
  }

  isEmailFilled(){
    return this.emailInput.valid;
  }

  getTranslationFor(placeholder){

    switch(placeholder){
      case 'email': 
        return this.translationService.getTranslatedText('AUTH.FORGOT_PASSWORD.EMAIL_PLACEHOLDER');
      case 'alt-1':
        return this.translationService.getTranslatedText('AUTH.FORGOT_PASSWORD.ALT.ALT1');
      default:
        return '';
        break;
    }

  }

}
